import {Component, Input, OnInit} from '@angular/core';
import {ExgModalService} from 'exc-controls-v2';
import {ApplicationService} from '../../services/application.service';
import {ExcTranslation} from 'exc-core-v2';
import {EnumerationService} from '../../services/enumeration.service';

@Component({
  selector: 'app-modal-oe-contact',
  templateUrl: './modal-oe-contact.component.html',
  styles: [
  ]
})
export class ModalOeContactComponent extends ExcTranslation implements OnInit {
  @Input() data: any;

  dataModel = {
    kont_enmIdent_KontaktTyp: 0,
    kontVal: ''
  };
  dataModelClone: any;
  oeContactTypList = [] as any[];

  constructor(
    private modalSvc: ExgModalService,
    public appSvc: ApplicationService,
    public enumSvc: EnumerationService
  ) {
    super();
  }

  ngOnInit(): void {
    const defaultValue = {
      enmName: 'KontaktTyp',
      enmIdent: 0,
      enmText: '- nicht ausgewählt -',
      enmTextA: '',
      enmSelector: '',
      enmSort: -1,
      enmDefault: false,
      enmVFR: 1385460834987,
      enmVTO: 2305102434990
    };
    this.oeContactTypList = this.oeContactTypList.concat(defaultValue, this.enumSvc.getEnumerationList('KontaktTyp'));

    if (!this.data) {
      this.dataModelClone = this.appSvc.helperObj.clone(this.dataModel);
    } else {
      this.dataModelClone = this.appSvc.helperObj.clone(this.data);
      this.dataModel = this.appSvc.helperObj.clone(this.data);
    }
  }

  delete(): void {
    this.modalSvc.action({kontID: this.dataModelClone?.kontID, del: true});
  }

  cancel(): void {
    this.close();
  }

  close(): void {
    this.modalSvc.close();
  }

  save(): void {
    if (this.appSvc.helperObj.changed(this.dataModel, this.dataModelClone)) {
      this.modalSvc.action(this.dataModelClone);
    }
  }
}
